var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demand"},[(_vm.wishBtn)?_c('div',{staticClass:"orderContent",on:{"click":_vm.toAddwish}},[_c('i',{staticClass:"iconfont icon-tubiao09"}),_c('p',[_vm._v("心愿")])]):_vm._e(),_c('activeData')],1)}
var staticRenderFns = []

export { render, staticRenderFns }